import React from 'react';

import { log } from '../../../services/utils';

import useToggle from '../../../hooks/useToggle';

import AuthForm from '../AuthForm';
import LoginForm from './LoginForm';
import ForgotPassForm from './ForgotPassForm';

const Login = () => {
	const [ forgotPass, toggleForgotPass ] = useToggle( false );

	return (
		<div id="login">
			{ log( 'login' ) }
			<AuthForm>
				{ forgotPass
					? <ForgotPassForm toggleForgotPass={ toggleForgotPass } />
					: <LoginForm toggleForgotPass={ toggleForgotPass } />
				}
			</AuthForm>
		</div>
	);
};

export default Login;
